import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { SystemSettingsService } from '../../services/system-settings/system-settings.service';

@Component({
  selector: 'app-screen-second-header',
  templateUrl: './screen-second-header.component.html',
  styleUrls: ['./screen-second-header.component.scss']
})
export class ScreenSecondHeaderComponent implements OnInit {

  //@Input() isFilters: boolean;
  logserviceHTML: SystemSettingsService;

  constructor(private logservice: SystemSettingsService) {
    this.logserviceHTML = logservice;
  }

  ngOnInit() {
    setTimeout(() => {
      let logserviceObj;
      //console.log(sessionStorage.getItem('SystemSettings'))
      //console.log(localStorage.getItem('SystemSettings'))
      if (sessionStorage.getItem('SystemSettings') != null) {
        logserviceObj = JSON.parse(sessionStorage.getItem('SystemSettings'));
      }
      else if (localStorage.getItem('SystemSettings') != null) {
        logserviceObj = JSON.parse(localStorage.getItem('SystemSettings'));
      }

      if (logserviceObj) {
        this.logserviceHTML.logDetail = logserviceObj.logDetail;
        this.logserviceHTML.LogType = logserviceObj.LogType;
        this.logserviceHTML.CompanyLogo = logserviceObj.CompanyLogo;
        this.logserviceHTML.CompanyRebrand = logserviceObj.CompanyRebrand;
        this.logserviceHTML.UserName = logserviceObj.UserName;
        this.logserviceHTML.isLoggedIn = logserviceObj.isLoggedIn;
        this.logserviceHTML.isCommonLogo = logserviceObj.isCommonLogo;
        this.logserviceHTML.startupScreen = logserviceObj.startupScreen;
        this.logserviceHTML.restrictScreens = logserviceObj.restrictScreens;
      }
      //console.log(this.logserviceHTML)
    });
  }

  @Output() RefreshClicked = new EventEmitter();
  onRefreshClicked(): void {
    //this.setCommonFilters();
    //let TSSelected = this.TSSelected;
    this.RefreshClicked.emit();
  }


  AutoRefSelected = '5';
  //Start = false;
  AutoRefStop: boolean = true;
  @Output() AutoRefreshClicked = new EventEmitter();
  onAutoRefreshClicked() {
    this.AutoRefStop = !this.AutoRefStop;
    this.AutoRefreshClicked.emit({ AutoRefSelected: parseInt(this.AutoRefSelected) * 1000, AutoRefStop: this.AutoRefStop });
  }

}
